// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: atdcK1hSZxqWg32TQQ3iWK
// Component: 4B0_21c2Tv
import * as React from "react";
import {
  PlasmicImg as PlasmicImg__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  hasVariant,
  renderPlasmicSlot,
  useCurrentUser
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import CoursesHeaderDay from "../../CoursesHeaderDay"; // plasmic-import: Rev9untEYR/component
import { useScreenVariants as useScreenVariantscmLbcqStcJj } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: CMLbcqStcJJ/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic_blank_website_mobile_first.module.css"; // plasmic-import: atdcK1hSZxqWg32TQQ3iWK/projectcss
import sty from "./PlasmicCoursesHeader.module.css"; // plasmic-import: 4B0_21c2Tv/css
import Icon4Icon from "./icons/PlasmicIcon__Icon4"; // plasmic-import: VecgZqNuXd/icon
import image5VrLwQlqPm from "./images/image5.png"; // plasmic-import: vrLwQlqPm/picture

createPlasmicElementProxy;

export const PlasmicCoursesHeader__VariantProps = new Array();

export const PlasmicCoursesHeader__ArgProps = new Array("days", "picker");

const $$ = {};

function PlasmicCoursesHeader__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {
          days: []
        },
        props.args
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = useCurrentUser?.() || {};
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantscmLbcqStcJj()
  });
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        sty.root
      )}
    >
      <div className={classNames(projectcss.all, sty.freeBox__fHnF6)}>
        <div className={classNames(projectcss.all, sty.freeBox__gomaW)}>
          {(
            hasVariant(globalVariants, "screen", "desktopOnly") ? true : false
          ) ? (
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__nOsgt
              )}
            >
              {"Valitse p\u00e4iv\u00e4"}
            </div>
          ) : null}
          {renderPlasmicSlot({
            defaultContents: null,
            value: args.picker
          })}
        </div>
        <div
          data-plasmic-name={"reloadBtn"}
          data-plasmic-override={overrides.reloadBtn}
          className={classNames(projectcss.all, sty.reloadBtn)}
        >
          {(
            hasVariant(globalVariants, "screen", "desktopOnly") ? true : false
          ) ? (
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__leVqq
              )}
            >
              {"P\u00e4ivit\u00e4"}
            </div>
          ) : null}
          {(
            hasVariant(globalVariants, "screen", "desktopOnly") ? true : false
          ) ? (
            <PlasmicImg__
              data-plasmic-name={"img"}
              data-plasmic-override={overrides.img}
              alt={""}
              className={classNames(sty.img)}
              displayHeight={"auto"}
              displayMaxHeight={"none"}
              displayMaxWidth={"100%"}
              displayMinHeight={"0"}
              displayMinWidth={"0"}
              displayWidth={"auto"}
              loading={"lazy"}
              src={{
                src: image5VrLwQlqPm,
                fullWidth: 48,
                fullHeight: 48,
                aspectRatio: undefined
              }}
            />
          ) : null}
          <Icon4Icon
            data-plasmic-name={"svg"}
            data-plasmic-override={overrides.svg}
            className={classNames(projectcss.all, sty.svg)}
            role={"img"}
          />
        </div>
      </div>
      <div className={classNames(projectcss.all, sty.freeBox___3Fi0)}>
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__nLoe5
          )}
        >
          {"Golfkent\u00e4t"}
        </div>
        <div className={classNames(projectcss.all, sty.freeBox__kjrTl)}>
          {(_par => (!_par ? [] : Array.isArray(_par) ? _par : [_par]))(
            (() => {
              try {
                return $props.days;
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return [];
                }
                throw e;
              }
            })()
          ).map((__plasmic_item_0, __plasmic_idx_0) => {
            const currentItem = __plasmic_item_0;
            const currentIndex = __plasmic_idx_0;
            return (
              <CoursesHeaderDay
                data-plasmic-name={"coursesHeaderDay"}
                data-plasmic-override={overrides.coursesHeaderDay}
                className={classNames("__wab_instance", sty.coursesHeaderDay)}
                date={(() => {
                  try {
                    return currentItem.date;
                  } catch (e) {
                    if (
                      e instanceof TypeError ||
                      e?.plasmicType === "PlasmicUndefinedDataError"
                    ) {
                      return undefined;
                    }
                    throw e;
                  }
                })()}
                day={(() => {
                  try {
                    return currentItem.day;
                  } catch (e) {
                    if (
                      e instanceof TypeError ||
                      e?.plasmicType === "PlasmicUndefinedDataError"
                    ) {
                      return undefined;
                    }
                    throw e;
                  }
                })()}
                key={currentIndex}
                tooltip={(() => {
                  try {
                    return currentItem.tooltip;
                  } catch (e) {
                    if (
                      e instanceof TypeError ||
                      e?.plasmicType === "PlasmicUndefinedDataError"
                    ) {
                      return undefined;
                    }
                    throw e;
                  }
                })()}
                weekend={(() => {
                  try {
                    return currentItem.weekend;
                  } catch (e) {
                    if (
                      e instanceof TypeError ||
                      e?.plasmicType === "PlasmicUndefinedDataError"
                    ) {
                      return false;
                    }
                    throw e;
                  }
                })()}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  root: ["root", "reloadBtn", "img", "svg", "coursesHeaderDay"],
  reloadBtn: ["reloadBtn", "img", "svg"],
  img: ["img"],
  svg: ["svg"],
  coursesHeaderDay: ["coursesHeaderDay"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicCoursesHeader__ArgProps,
          internalVariantPropNames: PlasmicCoursesHeader__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicCoursesHeader__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicCoursesHeader";
  } else {
    func.displayName = `PlasmicCoursesHeader.${nodeName}`;
  }
  return func;
}

export const PlasmicCoursesHeader = Object.assign(
  // Top-level PlasmicCoursesHeader renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    reloadBtn: makeNodeComponent("reloadBtn"),
    img: makeNodeComponent("img"),
    svg: makeNodeComponent("svg"),
    coursesHeaderDay: makeNodeComponent("coursesHeaderDay"),
    // Metadata about props expected for PlasmicCoursesHeader
    internalVariantProps: PlasmicCoursesHeader__VariantProps,
    internalArgProps: PlasmicCoursesHeader__ArgProps
  }
);

export default PlasmicCoursesHeader;
/* prettier-ignore-end */
